module.exports = __webpack_public_path__ + "img/tema-1-3.120ff5af.svg";